// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JFMY","fullView":"styles_fullView__SqVBY"};